import { useEffect, useRef } from 'react';

/**
 * Tracks how many times a boolean `value` has become `true`.
 * Uses a ref to avoid re-renders.
 *
 * @param value - The boolean value to watch.
 * @returns countRef - The number of times the value has become true.
 */
export function useValueChangeCounter(value: boolean) {
  const countRef = useRef(0);

  useEffect(() => {
    if (value) {
      countRef.current += 1;
    }
  }, [value]);

  return countRef;
}
